var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "19px",
    height: "19px",
    viewBox: "0 0 19 19",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "editar") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 19,
    height: 19
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Toppings",
    transform: "translate(-373.000000, -276.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(162.000000, 190.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-24-Copy",
    transform: "translate(211.000000, 80.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "editar",
    transform: "translate(0.000000, 6.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Background"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.0416195,9.53657167 C14.6038439,9.53657167 14.2499999,9.89197982 14.2499999,10.3297393 L14.2499999,16.6755149 C14.2499999,17.1125491 13.8952866,17.4686824 13.4583817,17.4686824 L2.37500002,17.4686824 C1.93795022,17.4686824 1.58338174,17.1125491 1.58338174,16.6755149 L1.58338174,5.57044375 C1.58338174,5.13341011 1.93795022,4.77727633 2.37500002,4.77727633 L8.70838227,4.77727633 C9.14615707,4.77727633 9.5,4.42186866 9.5,3.98410874 C9.5,3.54620361 9.14615707,3.190796 8.70838227,3.190796 L2.37500002,3.190796 C1.06558993,3.190796 0,4.25847123 0,5.57044375 L0,16.6755149 C0,17.9874879 1.06558993,19.055163 2.37500002,19.055163 L13.4583817,19.055163 C14.7677922,19.055163 15.833382,17.9874879 15.833382,16.6755149 L15.833382,10.3297393 C15.833382,9.89110791 15.4793935,9.53657167 15.0416195,9.53657167 L15.0416195,9.53657167 Z",
    id: "Shape",
    fill: "#81BF00",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.42264532,8.81399965 C7.36727111,8.86948205 7.33001681,8.94007029 7.31421632,9.01617692 L6.75453145,11.8210933 C6.72843892,11.9510853 6.76960714,12.0851438 6.86296043,12.1795513 C6.9381939,12.2549317 7.03951992,12.295309 7.14331022,12.295309 C7.16853299,12.295309 7.1947705,12.2929848 7.22086302,12.2874661 L10.0194323,11.726686 C10.0969851,11.7107099 10.167435,11.6735277 10.2220845,11.6178992 L16.485742,5.341986 L13.6871729,2.538086 L7.42264532,8.81399965 Z",
    id: "Shape",
    fill: "#81BF00",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.420531,0.598737744 C17.648772,-0.174676889 16.393142,-0.174676889 15.621963,0.598737744 L14.526367,1.69647814 L17.3249349,4.50052376 L18.420531,3.40263819 C18.7942339,3.02907512 19.000075,2.53089452 19.000075,2.00105093 C19.000075,1.47120752 18.7942339,0.973026871 18.420531,0.598737744 L18.420531,0.598737744 Z",
    id: "Shape",
    fill: "#81BF00",
    mask: "url(#mask-2)"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.d37fe506bb8d55689e024736e463074c.svg";
export { ForwardRef as ReactComponent };